<template>
  <v-container>
    <v-row class="text-center">
  
      <v-col class="mb-4">
        <h1 class="display-2 font-weight-bold mb-3">
          Welcome to the Vuetify 3 Beta
        </h1>

        <p class="subheading font-weight-regular">
          For help and collaboration with other Vuetify developers,
          <br />please join our online
          <a href="https://community.vuetifyjs.com" target="_blank"
            >Discord Community</a
          >
        </p>
      </v-col>
      <v-btn @click="fetchData()">GRZYBKI GRZYBKI </v-btn>

      <v-list>
      <v-list-item v-for="item in data" :key="item.id">
{{ item.name}}
<v-img :src="item.imageUrl">

</v-img>
      </v-list-item>
      </v-list>

      <v-col class="mb-5" cols="12">
        <h2 class="headline font-weight-bold mb-5">What's next?</h2>

        <v-row justify="center">
          TEST DLA ŁORDPRESSA! CZY TO ZADZIAŁA ????
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios';
export default {
  name: "HelloWorld",

  data: () => ({
    ecosystem: [
      {
        text: "vuetify-loader",
        href: "https://github.com/vuetifyjs/vuetify-loader/tree/next",
      },
      {
        text: "github",
        href: "https://github.com/vuetifyjs/vuetify/tree/next",
      },
      {
        text: "awesome-vuetify",
        href: "https://github.com/vuetifyjs/awesome-vuetify",
      },
    ],
    importantLinks: [
      {
        text: "Chat",
        href: "https://community.vuetifyjs.com",
      },
      {
        text: "Made with Vuetify",
        href: "https://madewithvuejs.com/vuetify",
      },
      {
        text: "Twitter",
        href: "https://twitter.com/vuetifyjs",
      },
      {
        text: "Articles",
        href: "https://medium.com/vuetify",
      },
    ],
    whatsNext: [
      {
        text: "Explore components",
        href: "https://vuetifyjs.com",
      },
      {
        text: "Roadmap",
        href: "https://vuetifyjs.com/introduction/roadmap/",
      },
      {
        text: "Frequently Asked Questions",
        href: "https://vuetifyjs.com/getting-started/frequently-asked-questions",
      },
    ],
    data: [],
  }),
  mounted(){
    this.fetchData();
  },
  methods:{
    async fetchData(){
      try {
      const response = await axios.get('https://dev.roboczy.com.pl/wp-json/wp/v2/product');
      console.log(response);
      const data = response.data;
      const items = [];

      for (let item of data) {
        try {
        const mediaResponse = await axios.get(`https://dev.roboczy.com.pl/wp-json/wp/v2/media/${item.featured_media}`);
        console.log(mediaResponse);
        items.push({
          name: item.title.rendered,
          id: item.featured_media,
          imageUrl: mediaResponse.data.guid.rendered
        });
        } catch (mediaError) {
        console.log(mediaError);
        }
      }

      this.data = items;
      } catch (error) {
      console.log(error);
      }
    }
  }
};
</script>
